import {connect} from 'react-redux'

import type {State} from '../../../reducers/types'
import {getBuildType, getIsSakuraUI} from '../../../selectors'
import {stringifyId} from '../../../types'
import {stringifyBranch} from '../../../utils/branchNames'
import {resolveWebEntityLink, WebEntityType} from '../../../utils/entityLinks'

import BranchLabel from './BranchLabel'
import type {BuildTypeBranchOwnProps, BuildTypeBranchStateProps} from './BranchLabel.types'

const mapStateToProps = (
  state: State,
  {buildTypeId, name, main}: BuildTypeBranchOwnProps,
): BuildTypeBranchStateProps => {
  const buildType = getBuildType(state, buildTypeId)
  const {projectId} = buildType || {}
  const branchNameInHref = stringifyBranch({
    name: name ?? '',
    default: main,
  })
  const params = new URLSearchParams()
  params.set(`branch_${stringifyId(projectId)}`, branchNameInHref)
  const buildTypeUrl = resolveWebEntityLink(WebEntityType.BUILD_TYPE, buildTypeId)
  return {
    isSakuraUI: getIsSakuraUI(state),
    branchNameInHref,
    href: buildTypeUrl != null ? `${buildTypeUrl}&${params.toString()}` : undefined,
  }
}

export default connect(mapStateToProps, {})(BranchLabel)
